export default __webpack_public_path__ + "img/e8ee06a6db9f3c17557b3c62fb67d62e.svg";